import React from 'react';
import { Link } from 'react-router-dom';

import {
    Button,
} from 'reactstrap';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Delete } from '@components/form'
import { StickyScrollbar } from './StickyScrollbar';

import './Table.css'
import { CONST_ROWS_PER_PAGE } from '@commons/consts';

class Table extends React.Component {

    constructor(props) {
        super(props);

        this.state = { rows: this.props.rows, first: 0 };
    }

    async componentDidMount() {
        if (this.props.auto) {
            await this.onPage({ rows: this.props.rows, page: 0, first: 0 });
        }

        await this.props.init();
    }

    onPage = async (event) => {
        await this.paginate({ rows: event.rows, page: event.page ?? 0 });
        this.setState({ rows: event.rows, first: event.first ?? 0 });
    }

    paginate = async ({ rows, page, args }) => {
        var size = 'size=' + rows;
        var page = 'page=' + (page);

        let total = '?' + size + '&' + page + (this.props.where != null && this.props.where != null ? `&${this.props.where}` : '');

        if (args) {
            total = total.concat(args)
        }

        await this.props.list(total);
    }

    render() {
        const refDt = React.createRef();
        const { reducer, paginator, lazy, showBtnExport, indexFieldMsgDelete, keyInput } = this.props;
        const { editLink, onRemove, onEdit } = this.props;

        const paginatorLeft = <React.Fragment />;

        return (
            <>
                {reducer.table &&
                    <StickyScrollbar>
                    <DataTable
                        key={'id_' + keyInput} ref={refDt} value={reducer.table.content} paginator={paginator} lazy={lazy} paginatorLeft={paginatorLeft}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} até {last} do total de {totalRecords} registros" rows={this.state.rows} rowsPerPageOptions={[10, 50, 100, 500]}
                        className='table table-striped my-4 w-100 p-datatable-sm' totalRecords={reducer.table.totalElements} autoLayout={true}
                        first={this.state.first} onPage={this.onPage} emptyMessage="Nenhum registro encontrado" csvSeparator=';'
                        scrollable={this.props.scrollable} 
                    >
                        {this.props.children}

                        {
                            <Column style={{ textAlign: 'center', width: this.props.actionWidth, minWidth: '120px', display: this.props.renderActions ? undefined : 'none' }}
                                body={(rowData, column) => {
                                    return (
                                        <div style={{ 
                                            display: 'flex', 
                                            gap: '5px', 
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexWrap: 'nowrap' // Mantém na mesma linha
                                        }}>

                                            {this.props.renderEdit &&
                                                <Link to={`${editLink}${rowData.id}`}>
                                                    <Button outline color='white' className='btn btn-warning btn-sm'
                                                        onClick={() => onEdit(rowData.id)}
                                                        style={{ marginRight: '5px' }}>
                                                        <i className='fas fa-pencil-alt' />
                                                    </Button>
                                                </Link>
                                            }

                                            {this.props.renderDelete &&
                                                <Delete registro={rowData} remove={onRemove}
                                                    removed={reducer.removed} indexFieldMsgDelete={indexFieldMsgDelete} />
                                            }
                                        </div>
                                    );
                                }} />
                        }
                    </DataTable>
                    </StickyScrollbar>
                }
            </>
        )

    }
}

Table.defaultProps = {
    keyInput: 'tableSearch',
    renderActions: true,
    paginator: true,
    lazy: true,
    renderEdit: true,
    renderDelete: true,
    actionWidth: '15%',
    scrollable: false,
    auto: true,
    showBtnExport: true,
    indexFieldMsgDelete: 0,
    rows: CONST_ROWS_PER_PAGE,
    onPage: () => { },
    onRemove: () => { },
    onEdit: () => { },
    init: () => { },
};

export { Table };